import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Select, Option} from 'kpc';

var _$tmp0 = {
    'style': 'margin-bottom: 16px;'
};
var _$tmp1 = {
    'loading': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Select, {
                'children': [
                    _$cc(Option, {
                        'value': 'Monday',
                        'children': '星期一'
                    }),
                    _$cc(Option, {
                        'value': 'Tuesday',
                        'children': '星期二'
                    }),
                    _$cc(Option, {
                        'value': 'Wednesday',
                        'children': '星期三'
                    }),
                    _$cc(Option, {
                        'value': 'Thursday',
                        'children': '星期四'
                    }),
                    _$cc(Option, {
                        'value': 'Friday',
                        'children': '星期五'
                    }),
                    _$cc(Option, {
                        'value': 'Saturday',
                        'children': '星期六'
                    }),
                    _$cc(Option, {
                        'value': 'Sunday',
                        'children': '星期天'
                    })
                ],
                'ev-$model:value': function($v) {
                    $this.set('day', $v);
                },
                'value': $this.get('day')
            }),
            _$ct('\n        You selected: '),
            this.get('day')
        ], 0, null, _$tmp0),
        _$cc(Select, _$tmp1)
    ], 4);
};